<template>
    <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" persistent
        transition-show="scale" transition-hide="scale">
        <q-card class="usuario-crud-card">
            <!-- Header mejorado -->
            <q-card-section class="card-header">
                <div class="row items-center no-wrap">
                    <q-avatar size="48px" color="white" text-color="primary">
                        <q-icon :name="props.oper === 'edit' ? 'edit' : 'person_add'" size="28px" />
                    </q-avatar>
                    <div class="col q-ml-md">
                        <div class="text-h5 text-weight-bold">{{ title }}</div>
                        <div class="text-caption text-white-7 q-mt-xs">
                            {{ props.oper === 'edit' ? 'Modifique los datos del usuario' : 'Complete los datos del nuevo usuario' }}
                        </div>
                    </div>
                    <q-btn flat dense round icon="close" color="white" v-close-popup size="md">
                        <q-tooltip>Cerrar</q-tooltip>
                    </q-btn>
                </div>
            </q-card-section>

            <q-separator />

            <!-- Contenido del formulario -->
            <q-card-section class="q-pa-lg form-content">
                <div class="row q-col-gutter-md">
                    <div class="col-12">
                        <div class="input-wrapper">
                            <div class="input-label">
                                <q-icon name="person" size="20px" color="primary" />
                                <span>Nombre completo</span>
                            </div>
                            <GltnInput v-model="form.name" label="Nombre" @update:model-value="validate($event, 'name')"
                                :errors="res.getErrors('name')">
                                <template v-slot:prepend>
                                    <q-icon name="badge" color="primary" />
                                </template>
                            </GltnInput>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="input-wrapper">
                            <div class="input-label">
                                <q-icon name="email" size="20px" color="primary" />
                                <span>Correo electrónico</span>
                            </div>
                            <GltnInput v-model="form.email" label="Email"
                                @update:model-value="validate($event, 'email')" :errors="res.getErrors('email')">
                                <template v-slot:prepend>
                                    <q-icon name="alternate_email" color="primary" />
                                </template>
                            </GltnInput>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="input-wrapper">
                            <div class="input-label">
                                <q-icon name="business_center" size="20px" color="primary" />
                                <span>Vendedor asociado</span>
                            </div>
                            <GltnSelectVendedores v-model="form.vendedor" label="Vendedor"
                                @update:model-value="validate($event, 'vendedor_id')"
                                :errors="res.getErrors('vendedor_id')">
                                <template v-slot:prepend>
                                    <q-icon name="assignment_ind" color="primary" />
                                </template>
                            </GltnSelectVendedores>
                        </div>
                    </div>

                    <div class="col-12">
                        <q-separator class="q-my-md" />
                        <div class="text-subtitle2 text-grey-7 q-mb-md">
                            <q-icon name="lock" size="18px" class="q-mr-xs" />
                            Credenciales de acceso
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="input-wrapper">
                            <div class="input-label">
                                <q-icon name="vpn_key" size="20px" color="primary" />
                                <span>Contraseña</span>
                            </div>
                            <GltnInput v-model="form.password" label="Contraseña" type="password"
                                @update:model-value="validate($event, 'password')" :errors="res.getErrors('password')">
                                <template v-slot:prepend>
                                    <q-icon name="password" color="primary" />
                                </template>
                            </GltnInput>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="input-wrapper">
                            <div class="input-label">
                                <q-icon name="verified_user" size="20px" color="primary" />
                                <span>Confirmar contraseña</span>
                            </div>
                            <GltnInput v-model="form.password_confirmation" label="Confirmar Contraseña" type="password"
                                @update:model-value="
                                    validate($event, 'password_confirmation')
                                    " :errors="res.getErrors('password_confirmation')">
                                <template v-slot:prepend>
                                    <q-icon name="check_circle" color="primary" />
                                </template>
                            </GltnInput>
                        </div>
                    </div>
                </div>
            </q-card-section>

            <q-separator />

            <!-- Acciones mejoradas -->
            <q-card-actions class="q-pa-md">
                <div class="row full-width q-gutter-sm">
                    <div class="col">
                        <q-btn unelevated label="Cancelar" color="grey-7" icon="close" v-close-popup
                            class="cancel-btn full-width" no-caps size="md" />
                    </div>
                    <div class="col">
                        <q-btn unelevated :label="props.oper === 'edit' ? 'Actualizar Usuario' : 'Crear Usuario'"
                            color="primary" :icon="props.oper === 'edit' ? 'save' : 'add'" @click="dataSave"
                            :disable="!res.valid" :loading="loading" class="save-btn full-width" no-caps size="md">
                            <template v-slot:loading>
                                <q-spinner-hourglass size="20px" />
                            </template>
                        </q-btn>
                    </div>
                </div>
            </q-card-actions>

            <q-inner-loading :showing="loading">
                <q-spinner-hourglass size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<script setup>
import GltnInput from "@/components/form/GltnInput.vue";
import GltnSelectVendedores from "@/components/form/GltnSelectVendedores.vue";
import UserService from "@/services/UserService";
import suite from "./UsuarioValidation";
import { reactive, ref, watch, computed } from "vue";
import { useQuasar } from "quasar";

const $q = useQuasar();
const res = ref();
const loading = ref(false);
res.value = suite.get();
const validate = (value, name) => {
    res.value = suite(name, form, props.oper);
};
const setValues = () => {
    for (let key in props.formulario) {
        form[key] = props.formulario[key];
    }
};

const props = defineProps({
    oper: [String],
    modelValue: {
        type: Boolean,
        default: false,
    },
    id: {
        type: [String, Number],
        default: null,
    },
    formulario: {
        type: Object,
        default: () => ({}),
    },
    vendedor: {
        type: Object,
        default: () => ({}),
    },
});

watch(
    () => props.modelValue,
    (newValue, oldValue) => {
        if (props.oper === "edit" && newValue) {
            setValues();
        }
        validate();
    }
);

const title = computed(() =>
    props.oper === "edit" ? "Editar Usuario" : "Crear Usuario"
);
const emits = defineEmits(["update:modelValue", "updated"]);
const form = reactive({
    id: null,
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    vendedor: null,
});

const dataSave = async () => {
    if (props.oper === "edit") {
        await userUpdate();
    } else {
        await userStore();
    }
}

const userStore = async () => {
    if (res.value.valid) {
        loading.value = true;
        const data = {
            ...form,
            vendedor_id: form.vendedor ? form.vendedor.id : null,
        };
        try {
            await UserService.store(data);
            emits("updated");
            emits("update:modelValue", false);
        } catch (error) {
            console.error("Error in userStore:", error);
            $q.notify({
                type: "negative",
                message: error.response.data.message,
            });
        } finally {
            loading.value = false;
        }
    }
};

const userUpdate = async () => {
    if (res.value.valid) {
        loading.value = true;
        const data = {
            ...form,
            vendedor_id: form.vendedor ? form.vendedor.value : null,
        };
        try {
            await UserService.update(data);
            $q.notify({
                type: "positive",
                message: "Usuario actualizado correctamente",
            });
            emits("updated");
            emits("update:modelValue", false);
        } catch (error) {
            console.error("Error in userUpdate:", error);
            $q.notify({
                type: "negative",
                message: error.response.data.message,
            });
        } finally {
            loading.value = false;
        }
    }
};
</script>

<style lang="scss" scoped>
@use 'sass:color';

.usuario-crud-card {
    width: 900px;
    max-width: 90vw;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    animation: scaleIn 0.3s ease;
}

.card-header {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    color: white;
    padding: 24px 28px;
}

.text-white-7 {
    color: rgba(255, 255, 255, 0.85);
}

// Contenido del formulario
.form-content {
    background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
    max-height: 65vh;
    overflow-y: auto;

    // Scrollbar personalizado
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f5f5f5;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(to bottom, #bdbdbd 0%, #9e9e9e 100%);
        border-radius: 4px;
        transition: background 0.3s ease;

        &:hover {
            background: linear-gradient(to bottom, #9e9e9e 0%, #757575 100%);
        }
    }
}

// Contenedores de inputs
.input-wrapper {
    margin-bottom: 8px;
}

.input-label {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #424242;
    letter-spacing: 0.3px;
}

// Inputs mejorados
:deep(.q-field) {
    .q-field__control {
        background: white;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:before {
            border-color: rgba(0, 0, 0, 0.15);
        }

        &:hover {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }
    }

    &.q-field--focused {
        .q-field__control {
            box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
        }
    }

    &.q-field--error {
        .q-field__control {
            box-shadow: 0 2px 8px rgba(244, 67, 54, 0.15);
        }
    }
}

// Sección de acciones

.cancel-btn {
    min-width: 140px;
    font-weight: 600;
    padding: 10px 24px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background: #f5f5f5;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
}

.save-btn {
    min-width: 180px;
    font-weight: 600;
    padding: 10px 24px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(25, 118, 210, 0.3);
    }

    &:disabled {
        opacity: 0.5;
    }
}

// Iconos mejorados
:deep(.q-icon) {
    transition: all 0.2s ease;
}

:deep(.q-field__prepend) {
    .q-icon {
        &:hover {
            transform: scale(1.1);
        }
    }
}

// Animación de entrada
@keyframes scaleIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

// Responsive
@media (max-width: 1023px) {
    .usuario-crud-card {
        width: 95vw;
        max-width: 95vw;
        border-radius: 12px;
    }

    .card-header {
        padding: 20px 24px;

        .text-h5 {
            font-size: 1.25rem;
        }
    }

    .form-content {
        padding: 24px 20px !important;
        max-height: 60vh;
    }

    .action-section {
        padding: 20px 24px !important;
        flex-direction: column;
        gap: 12px;

        .cancel-btn,
        .save-btn {
            width: 100%;
        }
    }
}

@media (max-width: 599px) {
    .usuario-crud-card {
        border-radius: 8px;
    }

    .card-header {
        padding: 16px 20px;

        .q-avatar {
            display: none;
        }

        .text-h5 {
            font-size: 1.1rem;
        }
    }

    .form-content {
        padding: 20px 16px !important;
        max-height: 55vh;
    }

    .input-label {
        font-size: 13px;
    }
}

// Estados de validación mejorados
:deep(.q-field--error) {
    .q-field__bottom {
        animation: shake 0.4s ease;
    }
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-4px);
    }

    75% {
        transform: translateX(4px);
    }
}

// Separador estilizado
:deep(.q-separator) {
    background: linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.12) 50%, transparent 100%);
    height: 1px;
}
</style>
